Vue.component('dropdown', {
        props: {
            modelValue: {
                type: Object,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            list: {
                type: Array,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },

        emits: ['update:modelValue'],

        data: function () {
            return {
                searchKeyword: '',
                currentItem: null,
                isDropdownOpen: false
            }
        },

        methods: {
            filteredList() {
                return this.list.filter(item => item.title.toLowerCase().includes(this.searchKeyword.toLowerCase()))
            },
            selectDropdownItem(item) {
                this.currentItem = item
                this.$emit('update:modelValue', item)
                this._closeList()
            },

            getDropdownParentClasses() {
                return {
                    'active': this.isDropdownOpen
                }
            },

            onOpenRequest() {
                if (!this.showDropdownContent()) {
                    return
                }

                if (this.isDropdownOpen) {
                    this._closeList()
                }
                else {
                    this._openList()
                }
            },

            showDropdownContent() {
                return this.list && this.list.length > 0
            },

            _closeList() {
                this.isDropdownOpen = false
                $(this.$refs.list).stop().slideUp('fast')
            },

            _openList() {
                this.isDropdownOpen = true
                $(this.$refs.list).stop().slideDown('fast')
            }
        },

        computed: {
            currentItemText() {
                if (!this.currentItem || !this.currentItem.title) {
                    return this.title
                }

                return this.currentItem.title
            },

            currentItemId() {
                if (!this.currentItem) {
                    return ''
                }

                return this.currentItem.code
            }
        },

        mounted() {
            this.currentItem = this.modelValue
        },

        created() {
            document.addEventListener('click', event => {
                if (this.$el.contains(event.target)) {
                    return
                }
                this._closeList()
            })
        },
        watch: {
            modelValue: function (val) {
                this.currentItem = val
            }
        }
    ,
template: `
    <div class="custom-select2-container">
        <div class="input custom-select2-header "
             :class="getDropdownParentClasses()"
             @click.prevent="onOpenRequest()">
            <span class="custom-select2-selected">
                {{currentItemText}}
            </span>
            <div class="custom-select2-arrow"></div>
        </div>

        <div class="custom-select2-list"
             v-show="isDropdownOpen">
            <input type="text"
                   class="custom-select2-search"
                   v-model="searchKeyword"
                   placeholder="search...">

            <div class="custom-select2-options">
                <div v-for="listItem in filteredList()"
                     class="custom-select2-option"
                     @click.prevent="selectDropdownItem(listItem)">
                    {{ listItem.title }}
                </div>

                <!--<div v-if="filteredOptions.length === 0 && searchTerm"
                     class="custom-select2-no-results">
                    No results found
                </div>-->
            </div>
        </div>
    </div>
`
});
Vue.component('multipleDropdown', {
        props: {
            modelValue: {
                type: Array,
                required: true,
                default: () => []
            },
            title: {
                type: String,
                required: true
            },
            list: {
                type: Array,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            showSelectedItems: {
                type: Boolean,
                default: false
            },
            maxSelections: {
                type: Number,
                default: null
            }
        },

        emits: ['update:modelValue'],

        data: function () {
            return {
                searchKeyword: '',
                selectedItems: [],
                isDropdownOpen: false
            }
        },

        methods: {
            filteredList() {
                return this.list.filter(item =>
                    item.title.toLowerCase().includes(this.searchKeyword.toLowerCase())
                )
            },

            toggleDropdownItem(item) {
                if (this.isItemSelected(item)) {
                    this.removeItem(item)
                } else {
                    this.addItem(item)
                }
            },

            addItem(item) {
                // Check if max selections reached
                if (this.maxSelections && this.selectedItems.length >= this.maxSelections) {
                    return
                }

                // Check if item already exists to prevent duplicates
                if (this.isItemSelected(item)) {
                    return
                }

                // Create new array with the new item
                const newSelectedItems = [...this.selectedItems, item]
                this.selectedItems = newSelectedItems
                this.$emit('update:modelValue', newSelectedItems)
            },

            removeItem(item) {
                // Create new array without the item
                const newSelectedItems = this.selectedItems.filter(selected =>
                    this.getItemKey(selected) !== this.getItemKey(item)
                )
                this.selectedItems = newSelectedItems
                this.$emit('update:modelValue', newSelectedItems)
            },

            isItemSelected(item) {
                return this.selectedItems.some(selected =>
                    this.getItemKey(selected) === this.getItemKey(item)
                )
            },

            getItemKey(item) {
                // Use code if available, otherwise use title as fallback
                return item.code || item.title || JSON.stringify(item)
            },

            clearAll() {
                this.selectedItems = []
                this.$emit('update:modelValue', [])
            },

            getDropdownParentClasses() {
                return {
                    'active': this.isDropdownOpen,
                    'disabled': this.disabled
                }
            },

            onOpenRequest() {
                if (this.disabled || !this.showDropdownContent()) {
                    return
                }

                if (this.isDropdownOpen) {
                    this._closeList()
                } else {
                    this._openList()
                }
            },

            showDropdownContent() {
                return this.list && this.list.length > 0
            },

            _closeList() {
                this.isDropdownOpen = false
                $(this.$refs.list).stop().slideUp('fast')
            },

            _openList() {
                this.isDropdownOpen = true
                $(this.$refs.list).stop().slideDown('fast')
            }
        },

        computed: {
            currentItemsText() {
                if (!this.selectedItems || this.selectedItems.length === 0) {
                    return this.title
                }

                if (this.selectedItems.length === 1) {
                    return this.selectedItems[0].title
                }

                return `არჩეულია ${this.selectedItems.length} კატეგორია`
            }
        },

        mounted() {
            // Initialize selectedItems from modelValue
            this.selectedItems = Array.isArray(this.modelValue) ? [...this.modelValue] : []
        },

        created() {
            document.addEventListener('click', event => {
                if (this.$el.contains(event.target)) {
                    return
                }
                this._closeList()
            })
        },

        watch: {
            modelValue: {
                handler(newVal) {
                    // Ensure we have a proper array and create a new reference
                    this.selectedItems = Array.isArray(newVal) ? [...newVal] : []
                },
                immediate: true,
                deep: true
            }
        }
    ,
template: `
    <div class="input custom-select2-container">
        <div class="custom-select2-header"
             :class="getDropdownParentClasses()"
             @click.prevent="onOpenRequest()">
            <span class="custom-select2-selected">
                {{currentItemsText}}
            </span>
            <div class="custom-select2-arrow"></div>
        </div>

        <div class="custom-select2-list mt-1"
             ref="list"
             v-show="isDropdownOpen">
            <input type="text"
                   class="custom-select2-search"
                   v-model="searchKeyword"
                   placeholder="search...">

            <div class="custom-select2-options">
                <div v-for="listItem in filteredList()"
                     class="custom-select2-multiple-option"
                     :class="{ 'selected': isItemSelected(listItem) }"
                     @click.prevent="toggleDropdownItem(listItem)">
                    <span class="option-text">{{ listItem.title }}</span>
                    <span v-if="isItemSelected(listItem)" class="checkmark">✓</span>
                </div>

                <div v-if="filteredList().length === 0 && searchKeyword"
                     class="custom-select2-multiple-no-results">
                    No results found
                </div>
            </div>

            <!--<div v-if="selectedItems.length > 0" class="custom-select2-multiple-actions">
                <button @click.prevent="clearAll()" class="clear-all-btn">
                    Clear All
                </button>
            </div>-->
        </div>

        <!-- Selected items display (optional - can be shown below dropdown) -->
        <div v-if="selectedItems.length > 0 && showSelectedItems" class="selected-items-display">
            <div v-for="item in selectedItems"
                 :key="item.id"
                 class="selected-item-tag">
                {{ item.title }}
                <span @click.prevent="removeItem(item)" class="remove-tag">×</span>
            </div>
        </div>
    </div>
`
});
Vue.component('addProduct', {
        props: [],
        data: function () {
            return {
                fileMaxSize: 30 * 1024 * 1024,

                sku: '',
                title: '',
                productUrl: '',
                selectedBrand: null,
                selectedCategories: [],
                files: {
                    manual: {
                        selected: false,
                        name: '',
                        size: '',
                        file: null,
                        hasError: false,
                        errorMessage: ''
                    },
                    report: {
                        selected: false,
                        name: '',
                        size: '',
                        file: null,
                        hasError: false,
                        errorMessage: '',
                        show: false
                    },
                    declaration: {
                        selected: false,
                        name: '',
                        size: '',
                        file: null,
                        hasError: false,
                        errorMessage: '',
                        show: false
                    },
                    certificate: {
                        selected: false,
                        name: '',
                        size: '',
                        file: null,
                        hasError: false,
                        errorMessage: '',
                        show: false
                    }
                },

                brands: [],
                suggestions: [],
                showSuggestions: false,
                categories: [],

                isLoading: false,
                errorMessage: '',
                submitted: false
            }
        },
        methods: {
            goToList() {
                window.location.href = window._data.listUrl;
            },
            saveProduct() {
                var _this = this;

                _this.submitted = true;
                _this.errorMessage = '';

                if (_this.isLoading) {
                    return;
                }

                if (!_this.sku || !_this.title || !_this.selectedBrand || !_this.selectedBrand.id || _this.selectedCategories.length == 0 || !_this.files.manual.selected) {
                    _this.errorMessage = 'შეიყვანეთ მონაცემები';
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                    return;
                }

                if (_this.sku.length <= 3) {
                    _this.errorMessage = 'მწარმოებლის კოდი უნდა შეიცავდეს მინიმუმ 4 სიმბოლოს';
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                    return;
                }

                if (_this.files.manual.selected && _this.files.manual.hasError) {
                    _this.errorMessage = _this.files.manual.errorMessage;
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                    return;
                }

                try {
                    _this.isLoading = true;

                    var endpointUrl = window._data.apiBaseUrl + 'ProductApi/AddProduct';

                    let formData = new FormData();
                    formData.append('langAbbr', window._data.languageAbbr);
                    formData.append('title', _this.title);
                    formData.append('sku', _this.sku);
                    formData.append('brandId', _this.selectedBrand.id);
                    formData.append('manual', _this.files.manual.file);
                    if (_this.productUrl) {
                        formData.append('productUrl', _this.productUrl);
                    }

                    // Append optional files if selected and valid
                    if (_this.files.report.selected && !_this.files.report.hasError) {
                        formData.append('report', _this.files.report.file);
                    }
                    if (_this.files.declaration.selected && !_this.files.declaration.hasError) {
                        formData.append('declaration', _this.files.declaration.file);
                    }
                    if (_this.files.certificate.selected && !_this.files.certificate.hasError) {
                        formData.append('certificate', _this.files.certificate.file);
                    }

                    _this.selectedCategories.forEach(category => {
                        formData.append('categories', category.id);
                    });

                    axios.post(endpointUrl, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                    ).then(function (response) {
                        if (response.data && response.data.succeeded) {
                            window.location.href = window._data.listUrl;
                        } else {
                            _this.errorMessage = response.data.message || 'არასწორი მონაცემები';
                            _this.isLoading = false;
                        }
                    }).catch(function (e) {
                        _this.isLoading = false;
                        _this.errorMessage = 'დაფიქსირდა შეცდომა.';
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                        });
                    }).finally(function (e) {
                    });
                } catch (error) {
                    _this.errorMessage = error.response?.data?.message || 'დაფიქსირდა შეცდომა.';
                    _this.isLoading = false;
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                } finally {
                }
            },
            onSelectionChange(selectedCategories) {
                console.log('Selected items:', selectedCategories)
            },

            triggerUpload(refName) {
                this.$refs[refName].click();
            },

            formatFileSize(bytes) {
                if (bytes === 0) return '0 Bytes';
                const k = 1024;
                const sizes = ['Bytes', 'KB', 'MB', 'GB'];
                const i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
            },

            showUploadButton(type) {
                var _this = this;
                _this.files[type].show = true;
            },

            handleFileSelect(event, type) {
                var _this = this;
                const file = event.target.files[0];

                if (file) {
                    // Check if it's a PDF
                    //if (file.type !== 'application/pdf') {
                    //    alert('Please select only PDF files.');
                    //    event.target.value = '';
                    //    return;
                    //}

                    const isPdfMimeType = file.type === 'application/pdf';
                    const isPdfExtension = file.name.toLowerCase().endsWith('.pdf');

                    // Update file state
                    _this.files[type] = {
                        selected: true,
                        name: file.name,
                        size: _this.formatFileSize(file.size),
                        file: file,
                        hasError: false,
                        errorMessage: '',
                        show: _this.files[type].show
                    };

                    if (!isPdfMimeType || !isPdfExtension) {
                        file.hasError = true;
                        file.errorMessage = 'დასაშვებია მხოლოდ PDF ფაილების ატვირთვა. ფაილი არ აიტვირთება!';
                        _this.fileList.push(file);
                    }
                    else if (file.size > _this.fileMaxSize) {
                        _this.files[type].hasError = true;
                        _this.files[type].errorMessage = 'ფაილის ზომა აღემატება დასაშვებ ლიმიტს. ფაილი არ აიტვირთება!';
                    } else {
                        _this.files[type].hasError = false;
                        _this.files[type].errorMessage = '';
                    }

                    // Emit event for parent component
                    _this.$emit('file-selected', {
                        type: type,
                        file: file
                    });
                }
            },

            removeFile(type) {
                // Clear the input
                const refName = type + 'Input';
                this.$refs[refName].value = '';

                // Reset file state
                this.files[type] = {
                    selected: false,
                    name: '',
                    size: '',
                    file: null,
                    show: this.files[type].show
                };

                // Emit event for parent component
                this.$emit('file-removed', {
                    type: type
                });
            },

            getSelectedFiles() {
                const selectedFiles = {};
                Object.keys(this.files).forEach(type => {
                    if (this.files[type].selected) {
                        selectedFiles[type] = this.files[type].file;
                    }
                });
                return selectedFiles;
            },

            clearAllFiles() {
                Object.keys(this.files).forEach(type => {
                    this.removeFile(type);
                });
            },

            loadBrands() {
                var _this = this;
                var endpointUrl = window._data.apiBaseUrl + 'ProductApi/LoadBrands';
                axios.post(endpointUrl,
                    {
                    })
                    .then(function (response) {
                        if (response.data.succeeded) {
                            _this.brands = response.data.data.result;
                        }
                    })
                    .catch(function (e) {

                    })
                    .finally(function (e) {
                    });
            },

            loadCategories() {
                var _this = this;
                var endpointUrl = window._data.apiBaseUrl + 'ProductApi/LoadCategories';
                axios.post(endpointUrl,
                    {
                    })
                    .then(function (response) {
                        if (response.data.succeeded) {
                            _this.categories = response.data.data.result;
                        }
                    })
                    .catch(function (e) {

                    })
                    .finally(function (e) {
                    });
            },

            getSuggestions() {
                var _this = this;
                _this.suggestions = [];
                var endpointUrl = window._data.apiBaseUrl + 'ProductApi/getSuggestions';
                if (_this.sku && _this.sku.length > 3) {

                    axios.post(endpointUrl,
                        {
                            sku: _this.sku,
                            langAbbr: window._data.langAbbr
                        })
                        .then(function (response) {
                            if (response.data.succeeded) {
                                _this.suggestions = response.data.data.list;
                                _this.showSuggestions = _this.suggestions.length > 0;
                            }
                        })
                        .catch(function (e) {

                        })
                        .finally(function (e) {
                        });
                }
            }
        },
        mounted() {
            this.loadBrands();
            this.loadCategories();
        },
        computed: {
        },
        watch: {
            sku: function (newValue) {
                if (newValue && newValue.length > 3) {
                    this.getSuggestions();
                }
            }
        },
        created() {
            document.addEventListener('click', event => {

                if (this.$el.contains(event.target) && event.target.classList.contains('suggestions')) {
                    return
                }
                this.showSuggestions = false;
            })
        }
    ,
template: `



    <div class="form-container vertical">
        <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
            <div class="lg:col-span-2" style="min-height:1000px">
                <div class="card adaptable-card pb-6 py-4 rounded-br-none rounded-bl-none">
                    <div class="card-body">


                        <div class="alert alert-danger" v-if="errorMessage.length > 0">
                            <div class="alert-content">
                                <span class="alert-icon">
                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 20 20" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"></path>
                                    </svg>
                                </span>
                                <div>{{errorMessage}}</div>
                            </div>
                        </div>


                        <!--<h5>Basic Information</h5>-->
                        <!--<p class="mb-6">Section to config basic product information</p>-->
                        <div class="form-item vertical"
                             :class="{'has-error' : submitted && !title.length}">
                            <div>
                                <label class="form-label mb-2">პროდუქტის დასახელება</label>
                                <input class="input"
                                       type="text"
                                       name="name"
                                       autocomplete="off"
                                       value=""
                                       v-model="title">
                            </div>
                        </div>

                        <div class="form-item vertical">
                            <div>
                                <label class="form-label mb-2">პროდუქტის ბმული (URL)</label>
                                <input class="input"
                                       type="text"
                                       name="productUrl"
                                       autocomplete="off"
                                       placeholder="https://example.com/product"
                                       value=""
                                       v-model="productUrl">
                            </div>
                        </div>

                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="col-span-1">
                                <div class="form-item vertical"
                                     :class="{'has-error' : submitted && !sku.length}">
                                    <label class="form-label mb-2">მწარმოებლის კოდი</label>
                                    <div>
                                        <!--<input class="input"
                    type="text"
                    name="code"
                    autocomplete="off"
                    placeholder="მწარმოებლის კოდი">-->

                                        <input type="text" class="input suggestions" required="" autocomplete="off" v-model="sku"
                                               @focus="getSuggestions()">
                                        <!--<label class="floating-label">მწარმოებლის კოდი</label>-->

                                        <div class="input-with-suggestion-dropdown " v-if="showSuggestions">
                                            <div class="input-with-suggestion-item" v-for="suggestion in suggestions">{{suggestion.title}}</div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="col-span-1">
                                <div class="form-item vertical">
                                    <label class="form-label mb-2">ბრენდი</label>
                                    <div>
                                        <dropdown v-model="selectedBrand"
                                                  :title="'აირჩიე ბრენდი'"
                                                  :list="brands"></dropdown>
                                        <!--<select class="input">
                        <option selected>Select...</option>
                        <option value="Trend">Trend</option>
                        <option value="Unisex">Unisex</option>
                    </select>-->
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-item vertical">
                            <label class="form-label mb-2">კატეგორია</label>
                            <div>
                                <multiple-dropdown v-model="selectedCategories"
                                                   title="აირჩიე კატეგორია..."
                                                   :list="categories"
                                                   :show-selected-items="true"
                                                   :max-selections="5"
                                                   @update:modelValue="onSelectionChange"></multiple-dropdown>
                            </div>
                        </div>


                        <div class="" style="margin-top:80px;">
                            <div class="add-manual-upload-container">
                                <div class="add-manual-upload-item"
                                     :class="{'has-file-error' : submitted && (!files.manual.selected || files.manual.hasError)}">
                                    <input ref="manualInput"
                                           type="file"
                                           class="add-manual-upload-input"
                                           accept=".pdf"
                                           @change="handleFileSelect($event, 'manual')" />
                                    <button type="button"
                                            class="add-manual-upload-button case-on"
                                            :disabled="files.manual.selected"
                                            @click="triggerUpload('manualInput')">
                                        ატვირთე ინსტრუქცია (manual)
                                    </button>

                                    <div v-if="files.manual.selected"
                                         class="add-manual-upload-file-info"
                                         :class="{'has-file-error' : files.manual.hasError }">
                                        <div class="add-manual-upload-file-details">
                                            <div class="add-manual-upload-file-name">{{ files.manual.name }}</div>
                                            <div class="add-manual-upload-file-size">{{ files.manual.size }}</div>
                                            <p v-if="files.manual.hasError" class="form_file_error">{{ files.manual.errorMessage }}</p>
                                        </div>
                                        <button type="button"
                                                class="add-manual-upload-remove case-on"
                                                @click="removeFile('manual')">
                                            წაშლა
                                        </button>
                                    </div>
                                </div>

                                <div class="add-manual-upload-item" v-show="files.report.show">
                                    <input ref="reportInput"
                                           type="file"
                                           class="add-manual-upload-input"
                                           accept=".pdf"
                                           @change="handleFileSelect($event, 'report')" />
                                    <button type="button"
                                            class="add-manual-upload-button case-on"
                                            :disabled="files.report.selected"
                                            @click="triggerUpload('reportInput')">
                                        ატვირთე ტესტ რეპორტი (Test report)
                                    </button>
                                    <div v-if="files.report.selected"
                                         class="add-manual-upload-file-info"
                                         :class="{'has-file-error' : files.report.hasError }">
                                        <div class="add-manual-upload-file-details">
                                            <div class="add-manual-upload-file-name">{{ files.report.name }}</div>
                                            <div class="add-manual-upload-file-size">{{ files.report.size }}</div>
                                            <p v-if="files.report.hasError" class="form_file_error">{{ files.report.errorMessage }}</p>
                                        </div>
                                        <button type="button"
                                                class="add-manual-upload-remove case-on"
                                                @click="removeFile('report')">
                                            წაშლა
                                        </button>
                                    </div>
                                </div>

                                <div class="add-manual-upload-item" v-show="files.declaration.show">
                                    <input ref="declarationInput"
                                           type="file"
                                           class="add-manual-upload-input"
                                           accept=".pdf"
                                           @change="handleFileSelect($event, 'declaration')" />
                                    <button type="button"
                                            class="add-manual-upload-button case-on"
                                            :disabled="files.declaration.selected"
                                            @click="triggerUpload('declarationInput')">
                                        ატვირთე დეკლარაცია (Declaration of conformity)
                                    </button>
                                    <div v-if="files.declaration.selected"
                                         class="add-manual-upload-file-info"
                                         :class="{'has-file-error' : files.declaration.hasError }">
                                        <div class="add-manual-upload-file-details">
                                            <div class="add-manual-upload-file-name">{{ files.declaration.name }}</div>
                                            <div class="add-manual-upload-file-size">{{ files.declaration.size }}</div>
                                            <p v-if="files.declaration.hasError" class="form_file_error">{{ files.declaration.errorMessage }}</p>
                                        </div>
                                        <button type="button"
                                                class="add-manual-upload-remove case-on"
                                                @click="removeFile('declaration')">
                                            წაშლა
                                        </button>
                                    </div>
                                </div>

                                <div class="add-manual-upload-item" v-show="files.certificate.show">
                                    <input ref="certificateInput"
                                           type="file"
                                           class="add-manual-upload-input case-on"
                                           accept=".pdf"
                                           @change="handleFileSelect($event, 'certificate')" />
                                    <button type="button"
                                            class="add-manual-upload-button case-on"
                                            :disabled="files.certificate.selected"
                                            @click="triggerUpload('certificateInput')">
                                        ატვირთე სერტიფიკატი (CE)
                                    </button>
                                    <div v-if="files.certificate.selected"
                                         class="add-manual-upload-file-info"
                                         :class="{'has-file-error' : files.certificate.hasError }">
                                        <div class="add-manual-upload-file-details">
                                            <div class="add-manual-upload-file-name">{{ files.certificate.name }}</div>
                                            <div class="add-manual-upload-file-size">{{ files.certificate.size }}</div>
                                            <p v-if="files.certificate.hasError" class="form_file_error">{{ files.certificate.errorMessage }}</p>
                                        </div>
                                        <button type="button"
                                                class="add-manual-upload-remove case-on"
                                                @click="removeFile('certificate')">
                                            წაშლა
                                        </button>
                                    </div>
                                </div>
                                <div style="display:ruby">
                                    <div class="add-manual-upload-add-button" v-show="!files.report.show" @click.prevent="showUploadButton('report')">+ ტესტ რეპორტის დამატება</div>
                                    <div class="add-manual-upload-add-button" v-show="!files.declaration.show" @click.prevent="showUploadButton('declaration')">+ დეკლარაციის დამატება</div>
                                    <div class="add-manual-upload-add-button" v-show="!files.certificate.show" @click.prevent="showUploadButton('certificate')">+ სერტიფიკატის დამატება</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="stickyFooter" class="sticky -bottom-1 -mx-8 px-8 flex items-center justify-end py-4 border-t bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700">

            <div class="md:flex items-center">
                <button class="case-on btn btn-default btn-sm ltr:mr-2 rtl:ml-2" type="button" @click.prevent="goToList()">გაუქმება</button>

                <button class="btn btn-solid btn-sm" type="submit" @click.prevent="saveProduct()">
                    <span class="flex items-center justify-center">
                        <span class="text-lg">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                <path d="M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"></path>
                            </svg>
                        </span>
                        <span class="case-on  ltr:ml-1 rtl:mr-1" v-if="!isLoading">შენახვა</span>
                        <span class="case-on " v-if="isLoading">დაელოდეთ...</span>
                    </span>
                </button>
            </div>
        </div>
    </div>


`
});
Vue.component('editProduct', {
        props: [],
        data: function () {
            return {
                fileMaxSize: 30 * 1024 * 1024,

                sku: '',
                title: '',
                productUrl: '',
                selectedBrand: null,
                selectedCategories: [],
                files: {
                    manual: {
                        selected: false,
                        name: '',
                        size: '',
                        file: null,
                        hasError: false,
                        errorMessage: ''
                    },
                    report: {
                        selected: false,
                        name: '',
                        size: '',
                        file: null,
                        hasError: false,
                        errorMessage: '',
                        show: false
                    },
                    declaration: {
                        selected: false,
                        name: '',
                        size: '',
                        file: null,
                        hasError: false,
                        errorMessage: '',
                        show: false
                    },
                    certificate: {
                        selected: false,
                        name: '',
                        size: '',
                        file: null,
                        hasError: false,
                        errorMessage: '',
                        show: false
                    }
                },

                brands: [],
                suggestions: [],
                showSuggestions: false,
                categories: [],

                isLoading: false,
                errorMessage: '',
                submitted: false
            }
        },
        methods: {
            goToList() {
                window.location.href = window._data.listUrl;
            },
            saveProduct() {
                var _this = this;

                _this.submitted = true;
                _this.errorMessage = '';

                if (_this.isLoading) {
                    return;
                }

                if (!_this.sku || !_this.title || !_this.selectedBrand || !_this.selectedBrand.id || _this.selectedCategories.length == 0) {
                    _this.errorMessage = 'შეიყვანეთ მონაცემები';
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                    return;
                }

                if (_this.sku.length <= 3) {
                    _this.errorMessage = 'მწარმოებლის კოდი უნდა შეიცავდეს მინიმუმ 4 სიმბოლოს';
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                    return;
                }

                if (_this.files.manual.selected && _this.files.manual.hasError) {
                    _this.errorMessage = _this.files.manual.errorMessage;
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                    return;
                }

                try {
                    _this.isLoading = true;

                    var endpointUrl = window._data.apiBaseUrl + 'ProductApi/EditProduct';

                    let formData = new FormData();
                    formData.append('langAbbr', window._data.languageAbbr);
                    formData.append('title', _this.title);
                    formData.append('sku', _this.sku);
                    formData.append('brandId', _this.selectedBrand.id);
                    formData.append('manual', _this.files.manual.file);
                    if (_this.productUrl) {
                        formData.append('productUrl', _this.productUrl);
                    }

                    // Append optional files if selected and valid
                    if (_this.files.report.selected && !_this.files.report.hasError) {
                        formData.append('report', _this.files.report.file);
                    }
                    if (_this.files.declaration.selected && !_this.files.declaration.hasError) {
                        formData.append('declaration', _this.files.declaration.file);
                    }
                    if (_this.files.certificate.selected && !_this.files.certificate.hasError) {
                        formData.append('certificate', _this.files.certificate.file);
                    }

                    _this.selectedCategories.forEach(category => {
                        formData.append('categories', category.id);
                    });

                    axios.post(endpointUrl, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                    ).then(function (response) {
                        if (response.data && response.data.succeeded) {
                            window.location.href = window._data.listUrl;
                        } else {
                            _this.errorMessage = response.data.message || 'არასწორი მონაცემები';
                            _this.isLoading = false;
                        }
                    }).catch(function (e) {
                        _this.isLoading = false;
                        _this.errorMessage = 'დაფიქსირდა შეცდომა.';
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                        });
                    }).finally(function (e) {
                    });
                } catch (error) {
                    _this.errorMessage = error.response?.data?.message || 'დაფიქსირდა შეცდომა.';
                    _this.isLoading = false;
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                } finally {
                }
            },
            onSelectionChange(selectedCategories) {
                console.log('Selected items:', selectedCategories)
            },

            triggerUpload(refName) {
                this.$refs[refName].click();
            },

            formatFileSize(bytes) {
                if (bytes === 0) return '0 Bytes';
                const k = 1024;
                const sizes = ['Bytes', 'KB', 'MB', 'GB'];
                const i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
            },

            showUploadButton(type) {
                var _this = this;
                _this.files[type].show = true;
            },

            handleFileSelect(event, type) {
                var _this = this;
                const file = event.target.files[0];

                if (file) {
                    // Check if it's a PDF
                    //if (file.type !== 'application/pdf') {
                    //    alert('Please select only PDF files.');
                    //    event.target.value = '';
                    //    return;
                    //}

                    const isPdfMimeType = file.type === 'application/pdf';
                    const isPdfExtension = file.name.toLowerCase().endsWith('.pdf');

                    // Update file state
                    _this.files[type] = {
                        selected: true,
                        name: file.name,
                        size: _this.formatFileSize(file.size),
                        file: file,
                        hasError: false,
                        errorMessage: '',
                        show: _this.files[type].show
                    };

                    if (!isPdfMimeType || !isPdfExtension) {
                        file.hasError = true;
                        file.errorMessage = 'დასაშვებია მხოლოდ PDF ფაილების ატვირთვა. ფაილი არ აიტვირთება!';
                        _this.fileList.push(file);
                    }
                    else if (file.size > _this.fileMaxSize) {
                        _this.files[type].hasError = true;
                        _this.files[type].errorMessage = 'ფაილის ზომა აღემატება დასაშვებ ლიმიტს. ფაილი არ აიტვირთება!';
                    } else {
                        _this.files[type].hasError = false;
                        _this.files[type].errorMessage = '';
                    }

                    // Emit event for parent component
                    _this.$emit('file-selected', {
                        type: type,
                        file: file
                    });
                }
            },

            removeFile(type) {
                // Clear the input
                const refName = type + 'Input';
                this.$refs[refName].value = '';

                // Reset file state
                this.files[type] = {
                    selected: false,
                    name: '',
                    size: '',
                    file: null,
                    show: this.files[type].show
                };

                // Emit event for parent component
                this.$emit('file-removed', {
                    type: type
                });
            },

            getSelectedFiles() {
                const selectedFiles = {};
                Object.keys(this.files).forEach(type => {
                    if (this.files[type].selected) {
                        selectedFiles[type] = this.files[type].file;
                    }
                });
                return selectedFiles;
            },

            clearAllFiles() {
                Object.keys(this.files).forEach(type => {
                    this.removeFile(type);
                });
            },

            loadBrands() {
                var _this = this;
                var endpointUrl = window._data.apiBaseUrl + 'ProductApi/LoadBrands';
                axios.post(endpointUrl,
                    {
                    })
                    .then(function (response) {
                        if (response.data.succeeded) {
                            _this.brands = response.data.data.result;

                            if (window.product.brandId) {
                                _this.selectedBrand = _this.brands.find((el) => el.id == window.product.brandId);
                            }

                            if (window.product.manualFileName && window.product.manualFileName.length) {
                                _this.files['manual'] = {
                                    selected: true,
                                    name: window.product.manualFileName,
                                    size: _this.formatFileSize(window.product.manualFileSize),
                                    //file: file,
                                    hasError: false,
                                    errorMessage: '',
                                    show: _this.files['manual'].show
                                };
                            }

                            if (window.product.reportFileName && window.product.reportFileName.length) {
                                _this.files['report'] = {
                                    selected: true,
                                    name: window.product.reportFileName,
                                    size: _this.formatFileSize(window.product.reportFileSize),
                                    hasError: false,
                                    errorMessage: '',
                                    show: true
                                };
                            }

                            if (window.product.declarationFileName && window.product.declarationFileName.length) {
                                _this.files['declaration'] = {
                                    selected: true,
                                    name: window.product.declarationFileName,
                                    size: _this.formatFileSize(window.product.declarationFileSize),
                                    hasError: false,
                                    errorMessage: '',
                                    show: true
                                };
                            }

                            if (window.product.certificateFileName && window.product.certificateFileName.length) {
                                _this.files['certificate'] = {
                                    selected: true,
                                    name: window.product.certificateFileName,
                                    size: _this.formatFileSize(window.product.certificateFileSize),
                                    hasError: false,
                                    errorMessage: '',
                                    show: true
                                };
                            }
                        }
                    })
                    .catch(function (e) {

                    })
                    .finally(function (e) {
                    });
            },

            loadCategories() {
                var _this = this;
                var endpointUrl = window._data.apiBaseUrl + 'ProductApi/LoadCategories';
                axios.post(endpointUrl,
                    {
                    })
                    .then(function (response) {
                        if (response.data.succeeded) {
                            _this.categories = response.data.data.result;

                            // Set selected categories after categories are loaded
                            if (window.product.categoryIds && window.product.categoryIds.length > 0) {
                                _this.selectedCategories = _this.categories.filter((el) => window.product.categoryIds.includes(el.id));
                            }
                        }
                    })
                    .catch(function (e) {

                    })
                    .finally(function (e) {
                    });
            },

            getSuggestions() {
                var _this = this;
                _this.suggestions = [];
                var endpointUrl = window._data.apiBaseUrl + 'ProductApi/getSuggestions';
                if (_this.sku && _this.sku.length > 3) {

                    axios.post(endpointUrl,
                        {
                            sku: _this.sku,
                            langAbbr: window._data.langAbbr
                        })
                        .then(function (response) {
                            if (response.data.succeeded) {
                                _this.suggestions = response.data.data.list;
                                _this.showSuggestions = _this.suggestions.length > 0;
                            }
                        })
                        .catch(function (e) {

                        })
                        .finally(function (e) {
                        });
                }
            },

            initProduct() {
                var _this = this;

                _this.title = window.product.title;
                _this.sku = window.product.sku;
                _this.productUrl = window.product.productUrl || '';

            }
        },
        mounted() {
            this.loadBrands();
            this.loadCategories();
            this.initProduct();
        },
        computed: {
        },
        watch: {
            sku: function (newValue) {
                if (newValue && newValue.length > 3) {
                    this.getSuggestions();
                }
            }
        },
        created() {
            document.addEventListener('click', event => {

                if (this.$el.contains(event.target) && event.target.classList.contains('suggestions')) {
                    return
                }
                this.showSuggestions = false;
            })
        }
    ,
template: `



    <div class="form-container vertical">
        <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
            <div class="lg:col-span-2" style="min-height:1000px">
                <div class="card adaptable-card pb-6 py-4 rounded-br-none rounded-bl-none">
                    <div class="card-body">

                        <div class="alert alert-danger" v-if="errorMessage.length > 0">
                            <div class="alert-content">
                                <span class="alert-icon">
                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 20 20" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"></path>
                                    </svg>
                                </span>
                                <div>{{errorMessage}}</div>
                            </div>
                        </div>


                        <!--<h5>Basic Information</h5>-->
                        <!--<p class="mb-6">Section to config basic product information</p>-->
                        <div class="form-item vertical"
                             :class="{'has-error' : submitted && !title.length}">
                            <div>
                                <label class="form-label mb-2">პროდუქტის დასახელება</label>
                                <input class="input"
                                       type="text"
                                       name="name"
                                       autocomplete="off"
                                       value=""
                                       v-model="title">
                            </div>
                        </div>

                        <div class="form-item vertical">
                            <div>
                                <label class="form-label mb-2">პროდუქტის ბმული (URL)</label>
                                <input class="input"
                                       type="text"
                                       name="productUrl"
                                       autocomplete="off"
                                       placeholder="https://example.com/product"
                                       value=""
                                       v-model="productUrl">
                            </div>
                        </div>

                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="col-span-1">
                                <div class="form-item vertical"
                                     :class="{'has-error' : submitted && !sku.length}">
                                    <label class="form-label mb-2">მწარმოებლის კოდი</label>
                                    <div>
                                        <!--<input class="input"
                                        type="text"
                                        name="code"
                                        autocomplete="off"
                                        placeholder="მწარმოებლის კოდი">-->

                                        <input type="text" class="input suggestions" required="" autocomplete="off" v-model="sku"
                                               disabled>
                                        <!--<label class="floating-label">მწარმოებლის კოდი</label>-->
                                        <!--<div class="input-with-suggestion-dropdown " v-if="showSuggestions">
                                            <div class="input-with-suggestion-item" v-for="suggestion in suggestions">{{suggestion.title}}</div>
                                        </div>-->

                                    </div>
                                </div>
                            </div>
                            <div class="col-span-1">
                                <div class="form-item vertical">
                                    <label class="form-label mb-2">ბრენდი</label>
                                    <div>
                                        <dropdown v-model="selectedBrand"
                                                  :title="'აირჩიე ბრენდი'"
                                                  :list="brands"></dropdown>
                                        <!--<select class="input">
                                            <option selected>Select...</option>
                                            <option value="Trend">Trend</option>
                                            <option value="Unisex">Unisex</option>
                                        </select>-->
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-item vertical">
                            <label class="form-label mb-2">კატეგორია</label>
                            <div>
                                <multiple-dropdown v-model="selectedCategories"
                                                   title="აირჩიე კატეგორია..."
                                                   :list="categories"
                                                   :show-selected-items="true"
                                                   :max-selections="5"
                                                   @update:modelValue="onSelectionChange"></multiple-dropdown>
                            </div>
                        </div>


                        <div class="" style="margin-top:80px;">
                            <div class="add-manual-upload-container">
                                <div class="add-manual-upload-item"
                                     :class="{'has-file-error' : submitted && (!files.manual.selected || files.manual.hasError)}">
                                    <input ref="manualInput"
                                           type="file"
                                           class="add-manual-upload-input"
                                           accept=".pdf"
                                           @change="handleFileSelect($event, 'manual')" />
                                    <button type="button"
                                            class="add-manual-upload-button case-on"
                                            :disabled="files.manual.selected"
                                            @click="triggerUpload('manualInput')">
                                        ატვირთე ინსტრუქცია (manual)
                                    </button>

                                    <div v-if="files.manual.selected"
                                         class="add-manual-upload-file-info"
                                         :class="{'has-file-error' : files.manual.hasError }">
                                        <div class="add-manual-upload-file-details">
                                            <div class="add-manual-upload-file-name">{{ files.manual.name }}</div>
                                            <div class="add-manual-upload-file-size">{{ files.manual.size }}</div>
                                            <p v-if="files.manual.hasError" class="form_file_error">{{ files.manual.errorMessage }}</p>
                                        </div>
                                        <button type="button"
                                                class="add-manual-upload-remove case-on"
                                                @click="removeFile('manual')">
                                            წაშლა
                                        </button>
                                    </div>
                                </div>

                                <div class="add-manual-upload-item" v-show="files.report.show">
                                    <input ref="reportInput"
                                           type="file"
                                           class="add-manual-upload-input"
                                           accept=".pdf"
                                           @change="handleFileSelect($event, 'report')" />
                                    <button type="button"
                                            class="add-manual-upload-button case-on"
                                            :disabled="files.report.selected"
                                            @click="triggerUpload('reportInput')">
                                        ატვირთე ტესტ რეპორტი (Test report)
                                    </button>
                                    <div v-if="files.report.selected"
                                         class="add-manual-upload-file-info"
                                         :class="{'has-file-error' : files.report.hasError }">
                                        <div class="add-manual-upload-file-details">
                                            <div class="add-manual-upload-file-name">{{ files.report.name }}</div>
                                            <div class="add-manual-upload-file-size">{{ files.report.size }}</div>
                                            <p v-if="files.report.hasError" class="form_file_error">{{ files.report.errorMessage }}</p>
                                        </div>
                                        <button type="button"
                                                class="add-manual-upload-remove case-on"
                                                @click="removeFile('report')">
                                            წაშლა
                                        </button>
                                    </div>
                                </div>

                                <div class="add-manual-upload-item" v-show="files.declaration.show">
                                    <input ref="declarationInput"
                                           type="file"
                                           class="add-manual-upload-input"
                                           accept=".pdf"
                                           @change="handleFileSelect($event, 'declaration')" />
                                    <button type="button"
                                            class="add-manual-upload-button case-on"
                                            :disabled="files.declaration.selected"
                                            @click="triggerUpload('declarationInput')">
                                        ატვირთე დეკლარაცია (Declaration of conformity)
                                    </button>
                                    <div v-if="files.declaration.selected"
                                         class="add-manual-upload-file-info"
                                         :class="{'has-file-error' : files.declaration.hasError }">
                                        <div class="add-manual-upload-file-details">
                                            <div class="add-manual-upload-file-name">{{ files.declaration.name }}</div>
                                            <div class="add-manual-upload-file-size">{{ files.declaration.size }}</div>
                                            <p v-if="files.declaration.hasError" class="form_file_error">{{ files.declaration.errorMessage }}</p>
                                        </div>
                                        <button type="button"
                                                class="add-manual-upload-remove case-on"
                                                @click="removeFile('declaration')">
                                            წაშლა
                                        </button>
                                    </div>
                                </div>

                                <div class="add-manual-upload-item" v-show="files.certificate.show">
                                    <input ref="certificateInput"
                                           type="file"
                                           class="add-manual-upload-input case-on"
                                           accept=".pdf"
                                           @change="handleFileSelect($event, 'certificate')" />
                                    <button type="button"
                                            class="add-manual-upload-button case-on"
                                            :disabled="files.certificate.selected"
                                            @click="triggerUpload('certificateInput')">
                                        ატვირთე სერტიფიკატი (CE)
                                    </button>
                                    <div v-if="files.certificate.selected"
                                         class="add-manual-upload-file-info"
                                         :class="{'has-file-error' : files.certificate.hasError }">
                                        <div class="add-manual-upload-file-details">
                                            <div class="add-manual-upload-file-name">{{ files.certificate.name }}</div>
                                            <div class="add-manual-upload-file-size">{{ files.certificate.size }}</div>
                                            <p v-if="files.certificate.hasError" class="form_file_error">{{ files.certificate.errorMessage }}</p>
                                        </div>
                                        <button type="button"
                                                class="add-manual-upload-remove case-on"
                                                @click="removeFile('certificate')">
                                            წაშლა
                                        </button>
                                    </div>
                                </div>
                                <div style="display:ruby">
                                    <div class="add-manual-upload-add-button" v-show="!files.report.show" @click.prevent="showUploadButton('report')">+ ტესტ რეპორტის დამატება</div>
                                    <div class="add-manual-upload-add-button" v-show="!files.declaration.show" @click.prevent="showUploadButton('declaration')">+ დეკლარაციის დამატება</div>
                                    <div class="add-manual-upload-add-button" v-show="!files.certificate.show" @click.prevent="showUploadButton('certificate')">+ სერტიფიკატის დამატება</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="stickyFooter" class="sticky -bottom-1 -mx-8 px-8 flex items-center justify-end py-4 border-t bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700">

            <div class="md:flex items-center">
                <button class="case-on btn btn-default btn-sm ltr:mr-2 rtl:ml-2" type="button" @click.prevent="goToList()">გაუქმება</button>

                <button class="btn btn-solid btn-sm" type="submit" @click.prevent="saveProduct()">
                    <span class="flex items-center justify-center">
                        <span class="text-lg">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                <path d="M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"></path>
                            </svg>
                        </span>
                        <span class="case-on  ltr:ml-1 rtl:mr-1" v-if="!isLoading">შენახვა</span>
                        <span class="case-on " v-if="isLoading">დაელოდეთ...</span>
                    </span>
                </button>
            </div>
        </div>
    </div>


`
});
Vue.component('manualRequestPopup', {
        data() {
            return {
                isOpen: false,
                step: 'form',
                productCode: '',
                productBrand: '',
                productTitle: '',
                phoneNumber: '',
                otpCode: '',
                errorMessage: '',
                successMessage: '',
                isLoading: false,
                submitted: false,
                resendCountdown: 0,
                resendTimer: null
            };
        },
        methods: {
            open(prefill) {
                this.isOpen = true;
                this.reset();
                if (prefill && prefill.productCode) {
                    this.productCode = prefill.productCode;
                }
                this.$nextTick(() => {
                    if (this.$refs.codeInput) this.$refs.codeInput.focus();
                });
            },
            close() {
                this.isOpen = false;
                this.reset();
            },
            reset() {
                this.step = 'form';
                this.productCode = '';
                this.productBrand = '';
                this.productTitle = '';
                this.phoneNumber = '';
                this.otpCode = '';
                this.errorMessage = '';
                this.successMessage = '';
                this.isLoading = false;
                this.submitted = false;
                this.clearResendTimer();
                this.resendCountdown = 0;
            },
            backToForm() {
                this.step = 'form';
                this.otpCode = '';
                this.errorMessage = '';
                this.submitted = false;
            },
            startResendCountdown() {
                var _this = this;
                _this.resendCountdown = 60;
                _this.clearResendTimer();
                _this.resendTimer = setInterval(function () {
                    _this.resendCountdown--;
                    if (_this.resendCountdown <= 0) {
                        _this.clearResendTimer();
                    }
                }, 1000);
            },
            clearResendTimer() {
                if (this.resendTimer) {
                    clearInterval(this.resendTimer);
                    this.resendTimer = null;
                }
            },
            sendOtp() {
                var _this = this;
                _this.submitted = true;
                _this.errorMessage = '';

                if (!_this.productCode.trim()) {
                    _this.errorMessage = 'პროდუქტის კოდი სავალდებულოა.';
                    return;
                }
                if (!_this.phoneNumber.trim()) {
                    _this.errorMessage = 'ტელეფონის ნომერი სავალდებულოა.';
                    return;
                }

                _this.isLoading = true;

                axios.post('/api/manualrequestapi/sendotp', {
                    phoneNumber: _this.phoneNumber.trim()
                })
                .then(function (response) {
                    if (response.data && response.data.succeeded) {
                        _this.step = 'otp';
                        _this.submitted = false;
                        _this.otpCode = '';
                        _this.startResendCountdown();
                        _this.$nextTick(function () {
                            if (_this.$refs.otpInput) _this.$refs.otpInput.focus();
                        });
                    } else {
                        _this.errorMessage = (response.data && response.data.message)
                            ? response.data.message
                            : 'შეცდომა. სცადეთ თავიდან.';
                    }
                })
                .catch(function () {
                    _this.errorMessage = 'კავშირის შეცდომა. სცადეთ თავიდან.';
                })
                .finally(function () {
                    _this.isLoading = false;
                });
            },
            submit() {
                var _this = this;
                _this.submitted = true;
                _this.errorMessage = '';

                if (!_this.otpCode.trim()) {
                    _this.errorMessage = 'დადასტურების კოდი სავალდებულოა.';
                    return;
                }

                _this.isLoading = true;

                axios.post('/api/manualrequestapi/submit', {
                    productCode:  _this.productCode.trim(),
                    productBrand: _this.productBrand.trim(),
                    productTitle: _this.productTitle.trim(),
                    phoneNumber:  _this.phoneNumber.trim(),
                    otpCode:      _this.otpCode.trim()
                })
                .then(function (response) {
                    if (response.data && response.data.succeeded) {
                        _this.successMessage = 'მოთხოვნა წარმატებით გაიგზავნა!';
                        _this.clearResendTimer();
                        setTimeout(function () { _this.close(); }, 2000);
                    } else {
                        _this.errorMessage = (response.data && response.data.message)
                            ? response.data.message
                            : 'შეცდომა. სცადეთ თავიდან.';
                    }
                })
                .catch(function () {
                    _this.errorMessage = 'კავშირის შეცდომა. სცადეთ თავიდან.';
                })
                .finally(function () {
                    _this.isLoading = false;
                });
            },
            onEsc(e) {
                if (e.key === 'Escape' && this.isOpen) this.close();
            }
        },
        mounted() {
            var _this = this;
            window.addEventListener('open-manual-request-popup', function (e) {
                _this.open(e && e.detail);
            });
            document.addEventListener('keydown', function (e) { _this.onEsc(e); });
        },
        beforeUnmount() {
            this.clearResendTimer();
        }
    ,
template: `
    <div>
        <div class="mr-overlay" v-if="isOpen" @click.self="close">
            <div class="mr-card">
                <button class="mr-close-btn" @click="close" aria-label="დახურვა">&times;</button>

                <div class="mr-icon-wrap">
                    <i class="fa fa-book"></i>
                </div>

                <!-- Step 1: Form -->
                <template v-if="step === 'form'">
                    <h5 class="mr-title case-on">სახელმძღვანელოს მოთხოვნა</h5>
                    <p class="mr-subtitle">შეავსეთ ველები. ნომრის დადასტურების შემდეგ მოთხოვნა გაიგზავნება.</p>

                    <div class="mr-error" v-if="errorMessage">{{ errorMessage }}</div>

                    <div class="mr-field">
                        <label>პროდუქტის კოდი <span class="mr-required">*</span></label>
                        <input type="text"
                               class="form-control"
                               :class="{'mr-input-error': submitted && !productCode.trim()}"
                               v-model="productCode"
                               placeholder="მაგ. WH-1000XM4"
                               autocomplete="off"
                               ref="codeInput" />
                    </div>
                    <div class="mr-field">
                        <label>ბრენდი</label>
                        <input type="text"
                               class="form-control"
                               v-model="productBrand"
                               placeholder="მაგ. Sony"
                               autocomplete="off" />
                    </div>
                    <div class="mr-field">
                        <label>პროდუქტის სახელი</label>
                        <input type="text"
                               class="form-control"
                               v-model="productTitle"
                               placeholder="მაგ. Wireless Headphones"
                               autocomplete="off" />
                    </div>
                    <div class="mr-field">
                        <label>ტელეფონის ნომერი <span class="mr-required">*</span></label>
                        <input type="tel"
                               class="form-control"
                               :class="{'mr-input-error': submitted && !phoneNumber.trim()}"
                               v-model="phoneNumber"
                               placeholder="მაგ. 5XXXXXXXX"
                               autocomplete="off"
                               ref="phoneInput" />
                    </div>
                    <div class="mr-actions">
                        <button class="btn btn-info mr-submit-btn case-on" @click="sendOtp" :disabled="isLoading">
                            <span v-if="!isLoading">SMS დადასტურება</span>
                            <span v-else><i class="fa fa-circle-o-notch fa-spin"></i></span>
                        </button>
                        <button class="btn btn-light mr-cancel-btn case-on" @click="close">გაუქმება</button>
                    </div>
                </template>

                <!-- Step 2: OTP -->
                <template v-if="step === 'otp'">
                    <h5 class="mr-title">ნომრის დადასტურება</h5>
                    <p class="mr-subtitle">4-ნიშნა კოდი გაგზავნილია ნომერზე:</p>
                    <div class="mr-otp-hint">
                        <i class="fa fa-mobile"></i> {{ phoneNumber }}
                    </div>

                    <div class="mr-error" v-if="errorMessage">{{ errorMessage }}</div>
                    <div class="mr-success" v-if="successMessage">
                        <i class="fa fa-check-circle"></i> {{ successMessage }}
                    </div>

                    <div v-if="!successMessage">
                        <div class="mr-field">
                            <label>დადასტურების კოდი <span class="mr-required">*</span></label>
                            <input type="text"
                                   class="form-control mr-otp-input"
                                   :class="{'mr-input-error': submitted && !otpCode.trim()}"
                                   v-model="otpCode"
                                   placeholder="X X X X"
                                   maxlength="4"
                                   autocomplete="one-time-code"
                                   ref="otpInput" />
                        </div>
                        <div class="mr-resend-row">
                            <span v-if="resendCountdown > 0" class="mr-resend-timer">
                                კოდის ხელახლა გაგზავნა — {{ resendCountdown }}წმ
                            </span>
                            <a v-else href="#" class="mr-resend" @click.prevent="sendOtp">
                                კოდის ხელახლა გაგზავნა
                            </a>
                        </div>
                        <div class="mr-actions">
                            <button class="btn btn-info mr-submit-btn case-on" @click="submit" :disabled="isLoading">
                                <span v-if="!isLoading">დადასტურება და გაგზავნა</span>
                                <span v-else><i class="fa fa-circle-o-notch fa-spin"></i></span>
                            </button>
                            <button class="btn btn-light mr-cancel-btn case-on" @click="backToForm">უკან</button>
                        </div>
                    </div>
                </template>

            </div>
        </div>
    </div>
`
});
Vue.component('productList', {
        data() {
            return {
                products: [],
                totalRecords: 0,
                filteredRecords: 0,
                currentPage: 1,
                pageSize: 20,
                search: '',
                searchInput: '',
                isLoading: false,
                draw: 0,
            };
        },
        computed: {
            totalPages() {
                return Math.max(1, Math.ceil(this.filteredRecords / this.pageSize));
            },
            startRow() {
                return (this.currentPage - 1) * this.pageSize + 1;
            },
            endRow() {
                return Math.min(this.currentPage * this.pageSize, this.filteredRecords);
            },
        },
        methods: {
            async loadProducts() {
                this.isLoading = true;
                this.draw++;
                try {
                    const url = window._data.apiBaseUrl + 'ProductApi/GetProductsListPaged';
                    const response = await axios.post(url, {
                        draw: this.draw,
                        start: (this.currentPage - 1) * this.pageSize,
                        length: this.pageSize,
                        search: this.search,
                    });
                    const d = response.data;
                    this.products = d.data || [];
                    this.totalRecords = d.recordsTotal || 0;
                    this.filteredRecords = d.recordsFiltered || 0;
                } catch (e) {
                    console.error('Error loading products', e);
                } finally {
                    this.isLoading = false;
                }
            },
            onClear() {
                this.search = '';
                this.searchInput = '';
                this.currentPage = 1;
                this.updateUrl();
                this.loadProducts();
            },
            onSearch() {
                this.search = this.searchInput;
                this.currentPage = 1;
                this.updateUrl();
                this.loadProducts();
            },
            goToPage(page) {
                this.currentPage = page;
                this.updateUrl();
                this.loadProducts();
            },
            updateUrl() {
                var params = new URLSearchParams(window.location.search);
                params.set('page', this.currentPage);
                if (this.search) {
                    params.set('search', this.search);
                } else {
                    params.delete('search');
                }
                var newUrl = window.location.pathname + '?' + params.toString();
                window.history.pushState(null, '', newUrl);
            },
            getEditUrl(id) {
                return window.editProductPageUrl + '?product=' + id;
            },
            getManualUrl(fileId, fileGuid) {
                return window.manualViewerPageUrl + '?f=' + fileId + '&g=' + fileGuid;
            },
            showLabel(productId) {
                if (window.showProductLabel) {
                    window.showProductLabel(productId);
                }
            },
        },
        mounted() {
            var params = new URLSearchParams(window.location.search);
            var page = parseInt(params.get('page'), 10);
            var search = params.get('search') || '';
            if (page > 1) this.currentPage = page;
            if (search) { this.search = search; this.searchInput = search; }
            this.loadProducts();
        }
    ,
template: `
    <div>
        <!-- Search -->
        <div class="flex gap-2 mb-4">
            <input class="input"
                   type="text"
                   placeholder="ძიება..."
                   v-model="searchInput"
                   @keyup.enter="onSearch"
                   style="max-width: 320px;" />
            <button class="btn btn-default" @click="onSearch">ძიება</button>
            <button class="btn btn-default" @click="onClear" v-if="search || searchInput">გასუფთავება</button>
        </div>

        <!-- Table -->
        <div class="overflow-x-auto">
            <table class="table-default table-hover">
                <thead>
                    <tr class="case-on">
                        <th>Id</th>
                        <th>კოდი</th>
                        <th>დასახელება</th>
                        <th>ბრენდი</th>
                        <th>სტატუსი</th>
                        <th>ინსტრუქცია</th>
                        <th>ტესტრეპორტი</th>
                        <th>დეკლარაცია</th>
                        <th>სერტიფიკატი</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="isLoading">
                        <td colspan="10" class="text-center py-6">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">იტვირთება...</span>
                            </div>
                        </td>
                    </tr>
                    <tr v-else-if="products.length === 0">
                        <td colspan="10" class="text-center py-6 text-gray-500">პროდუქტი არ მოიძებნა</td>
                    </tr>
                    <template v-else>
                        <tr v-for="row in products" :key="row.id">
                            <td>{{row.id}}</td>
                            <td>{{row.sku}}</td>
                            <td>{{row.productTitle}}</td>
                            <td>{{row.brandTitle}}</td>
                            <td><span class="capitalize font-semibold fs-10">გამოქვეყნებული</span></td>
                            <td>
                                <span v-if="row.manualFileId && row.manualFileGuid" class="capitalize font-semibold text-emerald-500 fs-12">
                                    <a class="no-wrap" :href="getManualUrl(row.manualFileId, row.manualFileGuid)" target="_blank">{{row.manualFileName || ''}}</a>
                                </span>
                                <span v-else class="capitalize font-semibold text-red-500 fs-10">არ არის ატვირთული</span>
                            </td>
                            <td><span class="capitalize font-semibold text-gray-500 fs-10">-----</span></td>
                            <td><span class="capitalize font-semibold text-gray-500 fs-10">-----</span></td>
                            <td><span class="capitalize font-semibold text-gray-500 fs-10">-----</span></td>
                            <td>
                                <div class="flex justify-end text-lg">
                                    <span class="cursor-pointer p-2 hover:text-indigo-900 font-semibold fs-10"
                                          style="min-width:55px;line-height:19px;"
                                          @click="showLabel(row.id)">Label</span>
                                    <span class="cursor-pointer p-2 hover:text-indigo-900 font-semibold fs-10"
                                          style="min-width:55px;line-height:19px;">QR code</span>
                                    <a :href="getEditUrl(row.id)" class="cursor-pointer p-2 hover:text-indigo-600">
                                        <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path></svg>
                                    </a>
                                    <span class="cursor-pointer p-2 hover:text-red-500">
                                        <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <div class="flex items-center justify-between mt-4" v-if="!isLoading && filteredRecords > 0">
            <div class="text-sm text-gray-500">
                {{startRow}}–{{endRow}} / {{filteredRecords}} ჩანაწერი
            </div>
            <div class="flex items-center gap-2">
                <button class="btn btn-default btn-sm" :disabled="currentPage <= 1" @click="goToPage(currentPage - 1)">&#8592;</button>
                <span class="text-sm">{{currentPage}} / {{totalPages}}</span>
                <button class="btn btn-default btn-sm" :disabled="currentPage >= totalPages" @click="goToPage(currentPage + 1)">&#8594;</button>
            </div>
        </div>
    </div>
`
});
Vue.component('search', {
        props: [],
        data: function () {
            return {
                keyword: '',
                suggestions: [],
                showSuggestions: false,
                abortController: null,
            }
        },
        methods: {
            openUrl(suggestion) {
                location.href = suggestion.url;
            },
            goToSearchResultPage() {
                if (this.keyword && this.keyword.trim().length > 0) {
                    window.location.href = window._data.searchResultPage + '?keyword=' + encodeURIComponent(this.keyword);
                }
            },
            async getSuggestions() {
                this.suggestions = [];

                if (!this.keyword || this.keyword.length <= 3) {
                    return;
                }

                if (this.abortController) {
                    this.abortController.abort();
                }

                this.abortController = new AbortController();

                try {
                    const endpointUrl = window._data.apiBaseUrl + 'searchapi/getsuggestions';

                    const response = await axios.post(endpointUrl, {
                        keyword: this.keyword,
                        langAbbr: window._data.languageAbbr
                    }, {
                        signal: this.abortController.signal
                    });

                    if (response.data && response.data.succeeded) {
                        this.suggestions = response.data.data.list || [];
                    }
                    this.showSuggestions = true;
                } catch (error) {
                    console.error('Error:', error);
                } finally {
                }
            }
        },
        mounted() {
        },
        computed: {
        },
        created() {
            document.addEventListener('click', event => {

                if (this.$el.contains(event.target) && event.target.classList.contains('suggestions')) {
                    return
                }
                this.showSuggestions = false;
            })
        }
    ,
template: `
    <div class="header_search_form">
        <div class="header_search_form_info">
            <div class="form-group">
                <div class="input-wrapper">
                    <i class="icon_search"></i>
                    <input type='search' class="suggestions" autocomplete="off" name="search"
                           placeholder="ჩაწერე პროდუქტის კოდი"
                           v-model="keyword"
                           @input="getSuggestions()"
                           @focus="getSuggestions()"
                           @keyup.enter="goToSearchResultPage()" />

                    <div class="header_search_form_panel" v-show="showSuggestions">
                        <div v-if="suggestions.length == 0" style="text-align:center;padding:20px 0">
                            არაფერი მოიძებნა
                        </div>

                        <!--<div class="header_search_keyword header_search_keyword-in text-center" style="border-top: 1px solid #434343; padding: 10px 0px 5px 0; " v-if="suggestions.length == 0">
                            <span class="header-search-form__keywords-label">ვერ იპოვე რასაც ეძებდი?</span>
                            <a href="" onclick="showPopup(event)" >მოითხოვე სახელმძღვანელოს დამატება</a>
                        </div>-->

                        <ul class="list-unstyled" v-if="suggestions.length > 0">
                            <li v-for="suggestion in suggestions">
                                <a href="" @click.prevent="openUrl(suggestion)">{{suggestion.title}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="header_search_keyword text-center">
            <span class="header-search-form__keywords-label">ვერ იპოვე რასაც ეძებდი?</span>
            <a href="" onclick="showPopup(event)" style="color:#fff">მოითხოვე სახელმძღვანელოს დამატება</a>
        </div>-->
    </div>
`
});
Vue.component('signIn', {
        props: [],
        data: function () {
            return {
                email: '',
                password: '',
                isLoading: false,
                errorMessage: '',
                submitted: false
            }
        },
        methods: {
            async login() {
                this.submitted = true;

                this.errorMessage = "";

                if (!this.email || !this.password) {
                    this.errorMessage = 'შეიყვანეთ მონაცემები';
                    return;
                }

                try {
                    this.isLoading = true;

                    const endpointUrl = window._data.authUrl + 'emailsignin';

                    const response = await axios.post(endpointUrl, {
                        email: this.email,
                        password: this.password,
                        persistent: true,
                        langAbbr: window._data.languageAbbr
                    });

                    if (response.data && response.data.succeeded) {
                        window.location.href = window._data.dashboardUrl;
                    } else {
                        this.errorMessage = response.data.message || 'დაფიქსირდა შეცდომა';
                        this.isLoading = false;
                    }
                } catch (error) {
                    console.error('Login error:', error);
                    this.errorMessage = error.response?.data?.message || 'ავტორიზაციის დროს დაფიქსირდა შეცდომა.';
                    this.isLoading = false;
                } finally {
                }
            }
        },
        mounted() {
        },
        computed: {
        }
    ,
template: `

    <div class="row login_form">
        <div class="col-lg-12 form-group"
             :class="{'has-error' : submitted && !email.length}">
            <div class="small_text">მომხმარებლის ელ. ფოსტა</div>
            <input type="email" class="form-control" placeholder="info@manuals.ge"
                   v-model="email"
                   @keyup.enter="login()" />
        </div>
        <div class="col-lg-12 form-group"
             :class="{'has-error' : submitted && !password.length}">
            <div class="small_text">მომხმარებლის პაროლი</div>
            <div class="confirm_password">
                <input name="confirm-password" type="password" class="form-control" placeholder="********" autocomplete="off"
                       v-model="password"
                       @keyup.enter="login()" />
                <a href="#" class="forget_btn">დაგავიწყდა პაროლი?</a>
            </div>
        </div>

        <div class="auth-error-message" v-if="errorMessage.length">
            {{errorMessage}}
        </div>

        <div class="col-lg-12 text-center">
            <button type="submit" class="btn action_btn thm_btn case-on" @click.prevent="login">
                <span v-if="!isLoading">შესვლა</span>
                <span v-if="isLoading">დაელოდეთ...</span>
            </button>
        </div>
    </div>

`
});
Vue.component('svg-icon', {
        props: ['icon'],
        data: function () {
            return {
                baseUrl: window._data.baseUrl
            };
        },
        methods: {
            getIconUrl: function () {
                return this.baseUrl + 'm/i/icons.svg#' + this.icon;
            }
        },
        mounted() {
        }
    ,
template: `
    <svg v-once><use v-bind="{\'xlink:href\' : getIconUrl()}" /></svg>
`
});
class EventBus {

    constructor() {
        this.addedToCart = new EventBus.Topic("added-to-cart")
        this.addedToFavorites = new EventBus.Topic("added-to-favorites")
        this.reloadAddresses = new EventBus.Topic("reload-addresses")
        this.showNotification = new EventBus.Topic("show-notification")
    }

    static Topic = class {
        #topic = '';
        #subsribers = []

        constructor(topic) {
            this.#topic = topic
        }

        get eventName() {
            return `eventbus.${this.#topic}`
        }

        notify(data) {
            for (let i = 0; i < this.#subsribers.length; i++) {
                try {
                    this.#subsribers[i](data)
                }
                catch { }
            }
        }

        subscribe(callback) {
            this.#subsribers.push(callback)
        }
    }
}

EventBus.shared = new EventBus()

var __phrases = {}

class PhrasesService {
    constructor() {
        if (!window._data || !window._data.phrases) {
            return;
        }

        for (var i = 0; i < window._data.phrases.length; i++) {
            var phrase = window._data.phrases[i];
            __phrases[phrase.T] = phrase.V;
        }
    }

    getPhrase(title) {
        if (!__phrases[title]) {
            return title;
        }

        return __phrases[title];
    }
}

PhrasesService.shared = new PhrasesService();
class SecurityService {
    getGoogleReCaptchaToken(action) {
        return grecaptcha.execute(window._data.reCaptchaSiteKey, { action: action });
    };
}

SecurityService.shared = new SecurityService()

document
    .querySelectorAll('[data-vueapp]')
    .forEach(element => {
        window._createVueApp(element);
    });

